import { styled } from "../styles"
import { flexCss } from "../Flex"

const Footer = styled.div({
  ...flexCss,
  justifyContent: `space-between`,
  alignItems: `center`,
})

Footer.displayName = `Message.Footer`

export { Footer }
